import React from 'react';
import { Modal, Select, Input } from 'antd';

const { Option } = Select;
const { TextArea } = Input;

const FIELD_TYPES = [
  { value: 'TextField', label: 'Text Field' },
  { value: 'MediaField', label: 'Media Field' },
  { value: 'MediaList', label: 'Media List' },
  { value: 'DatePicker', label: 'Date Picker' },
  { value: 'Poi', label: 'Tenants' },
];

function AddFieldModal({ visible, field, onChange, onSubmit, onCancel, isEdit }) {
  const isValid = field.fieldType && field.title;

  return (
    <Modal
      visible={visible}
      title={isEdit ? 'Edit Field' : 'Add New Field'}
      className="adsign-modal"
      closeIcon={<i className="feather-x" />}
      onOk={onSubmit}
      onCancel={onCancel}
      okText="Submit"
      okButtonProps={{
        className: isValid ? 'button-submit' : 'button-submit disabled',
        disabled: !isValid,
      }}
      cancelButtonProps={{
        className: 'button-cancel',
      }}
    >
      <div className="form">
        <label className="form-label">Field Type</label>
        <Select
          placeholder="Select type"
          value={field.fieldType}
          onChange={(value) => onChange({ ...field, fieldType: value })}
          style={{ width: '100%' }}
          className="select-adsign"
        >
          {FIELD_TYPES.map((type) => (
            <Option key={type.value} value={type.value}>
              {type.label}
            </Option>
          ))}
        </Select>
      </div>
      <div className="form">
        <label className="form-label">Title</label>
        <Input
          placeholder="Enter title"
          value={field.title}
          onChange={(e) => onChange({ ...field, title: e.target.value })}
          className="input-adsign"
        />
      </div>
      <div className="form">
        <label className="form-label">Description</label>
        <TextArea
          placeholder="Description"
          rows={4}
          value={field.description}
          onChange={(e) => onChange({ ...field, description: e.target.value })}
          className="input-adsign"
        />
      </div>
    </Modal>
  );
}

export default AddFieldModal;
